<script>
  import { ignore, makeWebsiteRequest } from "../../Common/tools";
  import { onMount } from "svelte";
  import Table from "../../Table/Table.svelte";
  import {External, M} from "../../external";

  export let data,
    onClick,
    query,
    onEmptyAction = ignore;

  let loading = true;
  let initialLoad = true;
  let table = null;

  let tableData = {
    columns: [
      {
        key: "name",
        label: M.NAME,
        class: "flex-1 mw-300 ws-normal",
        row: "created",
        rowLabel: M.CREATED_AT
      },
      { key: "subscribers", label: M.SUBSCRIBERS, type: "number", class: "mw-100" },
      { key: "open", label: M.OPEN_RATE, type: "percent", rowClass: "pay-status paid", class: "mw-100" },
      {
        key: "click",
        label: M.CLICK_RATE,
        type: "percent",
        rowClass: "order-status pending",
        class: "mw-100"
      },
      {
        type: "action",
        action: function (id, action, row) {
          if (action === "delete") {
            External.Tools.prompt(M.DELETE, M.SEGMENT_DELETE, function () {
              External.Tools.makeWebsiteRequest({
                action: "deleteMarketingSegment",
                data: {
                  id: id
                },
                onOk: function (response) {
                  load(0);
                }
              });
            });
          } else if (action === "rename") {
            External.Tools.promptForInput(M.DELETE, M.INSERT_SEGMENT_NAME, row.name, function (input) {
              row.name = input;
              row.created = null;
              External.Tools.makeWebsiteRequest({
                action: "setMarketingSegment",
                data: {
                  data: JSON.stringify(row)
                },
                onOk: function (response) {
                  tableData.rows = tableData.rows;
                  //load(0);
                }
              });
            });
          }
        },
        items: [
          { text: M.RENAME, icon: "fa-edit", tag: "rename" },
          { text: M.DELETE_TITLE, icon: "fa-trash", tag: "delete" }
        ],
        class: "mw-40"
      }
    ],
    rows: []
  };

  export function addItem(segment) {
    segment.created = External.Tools.dateToShortStr(new Date());
    tableData.rows.unshift(segment);
    data.count = tableData.rows.length;
    tableData.rows = tableData.rows;
  }

  let load = async (page) => {
    if (loading && !initialLoad) {
      return;
    }
    initialLoad = false;
    loading = true;
    tableData.rows = [];

    let request = {
        page: page,
        withStats: true,
        withSubscriberCount: true
      },
      filters = {};

    if (query !== "") {
      filters.name = query;
    }

    if (Object.keys(filters).length > 0) {
      request.filters = JSON.stringify(filters);
    }

    let response = await makeWebsiteRequest({
      action: "getMarketingSegments",
      data: request
    });

    let items = response.data;

    data.count = items.length;
    items.sort((first, second) => second.created - first.created);
    items.forEach((item) => {
      item.created = External.Tools.dateToShortStr(new Date(item.created));
    });

    if (table) table.addRows(items);
    loading = false;
  };

  const onClickRow = (row) => {
    onClick(row);
  };

  export function onReloadData() {
    load(0);
  }

  const nextPage = () => {};

  onMount(function () {
    // ignore, data is loaded from onReloadData
  });
</script>

<Table bind:this={table} data={tableData.rows} activeColumns={tableData.columns} loading={loading} onClick={onClickRow} nextPage={nextPage}>
  <div class="text-center col20 f-left" style="padding: 70px 30px; box-sizing: border-box;">
    <h4 class="col20 f-left t-center mb-15">{M.NO_SEGMENTS_AVAILABLE}</h4>
    <div class="col20 f-left t-center">
      <a class="middle-button blue with-icon inline-block f-none" on:click={onEmptyAction}> {M.ADD_SEGMENT} </a>
    </div>
  </div>
</Table>
